export default {
  getCep: state => state.cep,
  getStreet: state => state.street,
  getNumber: state => state.number,
  getNoNumber: state => state.noNumber,
  getNeighborhood: state => state.neighborhood,
  getState: state => state.state,
  getCity: state => state.city,
  getCityName: state => state.cityName,
  getComplements: state => state.complements,
  getLatitude: state => state.latitude,
  getLongitude: state => state.longitude,
  getAvailableBoxes: state => state.availableBoxes,
  getCto: state => state.cto,
  getCoverageStatus: state => state.coverageStatus,
  getCurrentLatitude: state => state.currentLatitude,
  getCurrentLongitude: state => state.currentLongitude,
  getCepFromCurrentLocation: state => state.cepFromCurrentLocation,
  getHasMadeCepFromCurrentLocationRequest: state =>
    state.hasMadeCepFromCurrentLocationRequest,
  getLocationType: state => state.locationType
}
